module.exports = __webpack_public_path__ + "img/ershoufang.c65fb3cb.png";